import {
  baseServiceInvoiceSchema,
  ServiceInvoiceType,
} from "@redotech/redo-model/billing/service-invoice";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const marketingInvoiceTypes = [
  ServiceInvoiceType.MARKETING_EMAIL,
  ServiceInvoiceType.MARKETING_SMS,
] as const satisfies ServiceInvoiceType[];

export const getFinalizedServiceInvoices = {
  name: "getFinalizedServiceInvoices" as const,
  input: z.null(),
  output: z.array(
    baseServiceInvoiceSchema.extend({
      type: createEnum(marketingInvoiceTypes, {
        enumName: "MarketingInvoiceType",
      }),
    }),
  ),
};
